export function customLoaderStop(){
    $('.custom-loader').removeClass('loader-wrapper-test loader-ring-test');
}